<template>
   <button :class="clases" :id="props.id" @click.prevent="handleClick" style="display: flex; gap: 8px;"
      @mousedown="handleOnmousedown" @mouseup="handleOnmouseup">
      <slot name="icon-izquierda"></slot>
      {{ props.label }}
      <slot name="icon-derecha"></slot>
   </button>
</template>
<script setup>
import { computed, defineProps } from 'vue';
import '../../assets/css/config.css'
const props = defineProps({
   id: { type: String, },
   variant: { type: String, default: 'white' },
   size: { type: String, default: 's' },
   label: { type: String, default: 'Iniciar' },
   width: { type: String },
   radius: { type: String, default: 'xl' },
   class: { type: String },
   onclick: {type: Function},
   onmouseup: {type: Function},
   onmousedown: {type: Function}
})
const handleClick = () => {
if(props.onclick) {
   props.onclick()
}
}
const handleOnmouseup = () => {
   if(props.onmouseup) {
   props.onmouseup()
}
};
const handleOnmousedown = () => {
   if(props.onmousedown) {
   props.onmousedown()
}
};
const clases = computed(() => {
   return {
      [`button-variante-${props.variant} button-size-${props.size} button-radius-${props.radius} ${props.class} pandora-button`]: true
   }
})
</script>
<style>
.pandora-button {
   cursor: pointer;
   font-family: Rubik-semibold, sans-serif;
   font-size: 16px;
   letter-spacing: 0.2px;
}
.button-variante-white {
   border: 1px solid #CDCED9;
   background-color: #FFFFFF;
   color: var(--color-dark-l3);
}
.button-variante-dark {
   background-color: var(--color-dark);
   color: #FFFFFF;
   border: none;
}
.button-variante-dark-l1 {
   background-color: var(--color-dark-l1);
   color: #FFFFFF;
   border: none;
}
.button-variante-dark-l2 {
   background-color: var(--color-dark-l2);
   color: #FFFFFF;
   border: none;
}
.button-variante-dark-l3 {
   background-color: var(--color-dark-l3);
   color: #FFFFFF;
   border: none;
}
.button-variante-dark-d1 {
   background-color: var(--color-dark-d1);
   color: #FFFFFF;
   border: none;
}
.button-variante-primary {
   background-color: var(--color-primary);
   color: #FFFFFF;
   border: none;
}
.button-variante-light {
   background-color: var(--color-light);
   border-color: rgb(126, 124, 124);
   border: 1px solid #CDCED9;
}
.button-variante-primary-d1 {
   background-color: var(--color-primary-d1);
   border-color: rgb(126, 124, 124);
   padding: 12px 16px 12px 16px;
   border: none;
   font-weight: 700;
   color: var(--color-light)
}
.button-variante-primary-d2 {
   background-color: var(--color-primary-d2);
   border: none;
   color: var(--color-light)
}
.button-variante-primary-l1 {
   background-color: var(--color-primary-l1);
   border: none;
   color: var(--color-light)
}
.button-variante-primary-l2 {
   background-color: var(--color-primary-l2);
   color: var(--color-dark-d1);
   border: 1px solid var(--color-dark-d1);
}
.button-variante-primary-l3 {
   background-color: var(--color-primary-l3);
   color: var(--color-dark-d1);
   border: 1px solid var(--color-dark-d1);
}
.button-variante-yellow {
   background-color: var(--color-yellow);
   color: white;
   border: none;
}
.button-variante-teal {
   background-color: var(--color-teal);
   color: white;
   border: none;
}
.button-variante-green {
   background-color: var(--color-green);
   color: #FFFFFF;
   border: none;
}
.button-variante-orange {
   background-color: var(--color-orange);
   color: var(--color-dark-d1);
   border: 1px solid var(--color-dark-d1);
   ;
}

.auto {
   width: auto;
}
.buttonflex {
   display: flex;
   gap: 4px;
}
.icon {
   width: 10px;
}
.button-size-s {
   padding: var(--padding-s);
}
.button-size-m {
   padding: var(--padding-m);
}
.button-size-l {
   padding: var(--padding-l);
}
.button-size-xl {
   padding: var(--padding-xl);
}
.button-radius-s {
   border-radius: 4px;
}
.button-radius-m {
   border-radius: 8px;
}
.button-radius-l {
   border-radius: 16px;
}
.button-radius-xl {
   border-radius: 24px;
}
@media (max-width: 500px) {
   .button-variante-black {
      width: 100%;
   }
   .button-variante-white {
      width: 100%;
   }
   .button-variante-yellow {
      width: 100%;
   }
}
</style>